import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { Text, Youtube } from "@cinch-labs/design-system";
import { BLOK_YOUTUBE, getStoryblokImageServiceUrl, isYoutubeBlok } from "@cinch-nx/data-storyblok";
import { MARK_BOLD, MARK_LINK, NODE_IMAGE, NODE_PARAGRAPH, render } from "storyblok-rich-text-react-renderer";
import { useAnalytics } from "@cinch-nx/shared-analytics";
import styles from "./rich-text-renderer.module.css";
var resolveYoutubeVideo = function(props) {
    return isYoutubeBlok(props) ? /*#__PURE__*/ _jsx(Youtube, _object_spread_props(_object_spread({}, props), {
        className: styles.video,
        customThumbnail: props.thumbnail.filename
    })) : null;
};
/**
 * Renders Storyblok Rich Text body with custom options
 * @param body - Storyblok Rich Text field
 * @param options - Custom options
 *  - makeId: boolean - Adds an id to the bold text (this was already here, didn't want breaking change so left it)
 *  - link: ILinkOptions - Custom link options
 *    - openNewTab: boolean - Specify if the link should open in a new tab
 *    - adobeTracking: TrackingEvent - Specify the adobe tracking event for the link
 * @returns React.ReactNode
 */ var renderWithResolver = function(body, options) {
    var _obj;
    return render(body, {
        nodeResolvers: (_obj = {}, _define_property(_obj, NODE_IMAGE, function(_, props) {
            var _src;
            var optimizedImageUrl = getStoryblokImageServiceUrl((_src = props.src) !== null && _src !== void 0 ? _src : "", {
                filters: [
                    {
                        quality: 80
                    }
                ]
            });
            return /*#__PURE__*/ _jsx("img", _object_spread_props(_object_spread({}, props), {
                src: optimizedImageUrl,
                style: {
                    height: "auto"
                },
                alt: props.alt
            }));
        }), _define_property(_obj, NODE_PARAGRAPH, function(children) {
            return children ? /*#__PURE__*/ _jsx(Text, {
                className: styles.rtParagraph,
                children: children
            }) : null;
        }), _obj),
        blokResolvers: _define_property({}, BLOK_YOUTUBE, function(props) {
            return resolveYoutubeVideo(props);
        }),
        markResolvers: _object_spread(_define_property({}, MARK_LINK, function(children, props) {
            var ref;
            var trackEvent = useAnalytics().trackEvent;
            return /*#__PURE__*/ _jsx("a", {
                href: props.href,
                target: (options === null || options === void 0 ? void 0 : (ref = options.link) === null || ref === void 0 ? void 0 : ref.openNewTab) ? "_blank" : "_self",
                rel: "noopener noreferrer",
                onClick: function() {
                    var ref, ref1;
                    return (options === null || options === void 0 ? void 0 : (ref = options.link) === null || ref === void 0 ? void 0 : ref.adobeTracking) ? trackEvent(options === null || options === void 0 ? void 0 : (ref1 = options.link) === null || ref1 === void 0 ? void 0 : ref1.adobeTracking) : null;
                },
                children: children
            });
        }), (options === null || options === void 0 ? void 0 : options.makeId) && _define_property({}, MARK_BOLD, function(children) {
            /*#__PURE__*/ return _jsx("strong", {
                id: children === null || children === void 0 ? void 0 : children.toLocaleString().replace(/\s/g, ""),
                children: children
            });
        }))
    });
};
export default renderWithResolver;
